/**
 * @generated SignedSource<<73562fb5ab61ac7ea658b10953a0bb42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemSearchFollowTheTimelineArticleSearchResultStreamItemTimelineSummary$data = {
  readonly humanReadableDate: string;
  readonly id: string;
  readonly summary: string;
  readonly " $fragmentType": "itemSearchFollowTheTimelineArticleSearchResultStreamItemTimelineSummary";
};
export type itemSearchFollowTheTimelineArticleSearchResultStreamItemTimelineSummary$key = {
  readonly " $data"?: itemSearchFollowTheTimelineArticleSearchResultStreamItemTimelineSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemSearchFollowTheTimelineArticleSearchResultStreamItemTimelineSummary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemSearchFollowTheTimelineArticleSearchResultStreamItemTimelineSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "humanReadableDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    }
  ],
  "type": "ArticleSearchResultStreamItemTimelineSummary",
  "abstractKey": null
};

(node as any).hash = "73cfd52456bed613c373c315a66c40b3";

export default node;
